export const itemsLinks = {
  2023: [
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2023',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2023',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2023',
    },
    {
      name: 'Mortgages',
      url: '/l/awards-mortgages-2023',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2023',
    },
    {
      name: 'Student Loans',
      url: '/l/awards-student-loans-2023',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2023',
    },
    {
      name: 'Travel',
      url: '/l/awards-travel-2023',
    },
  ],
  2024: [
    {
      name: 'Credit Cards',
      url: '/l/awards-credit-cards-2024',
    },
    {
      name: 'Personal Loans',
      url: '/l/awards-personal-loans-2024',
    },
    {
      name: 'Student Loans',
      url: '/l/awards-student-loans-2024',
    },
    {
      name: 'Banking',
      url: '/l/awards-banking-2024',
    },
    {
      name: 'Investing',
      url: '/l/awards-investing-2024',
    },
    {
      name: 'Mortgages',
      url: '/l/awards-mortgages-2024',
    },
    {
      name: 'Insurance',
      url: '/l/awards-insurance-2024',
    },
    {
      name: 'Travel Rewards',
      url: '/l/awards-travel-rewards-2024',
    },
  ],
};

export const logoLink = {
  name: 'Home',
  url: '/l/awards',
};
